import styled from "styled-components";

export default styled.div`
  position: sticky;
  height: 0px;
  top: 0px;
  left: 0px;
  z-index: 1;

  .drawer-container {
    height: calc(var(--vh, 1vh) * 100);
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin-left: 10px;

    .drawer-content {
      padding: 0.75rem;
      display: flex;
      height: 97vh;
      /* flex-flow: column nowrap; */
      justify-content: space-between;
      align-items: flex-start;
      flex: 0;
      width: fit-content;
      border-radius: 10px;
      max-width: 250px;
      overflow: hidden;
      flex: 1;

      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
      background-color: white;

      .menu-wrapper {
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;
        flex: 1;
        height: 100%;

        .main-menu {
          display: flex;
          flex-flow: column;
          gap: 2rem;

          .main-section {
            display: flex;
            flex-flow: column;
            gap: 1rem;
          }
        }
        .option-section {
          display: flex;
          flex-flow: column;
          gap: 1.5rem;
          width: 100%;
        }
      }
    }

    .config-menu {
    }
  }

  @media screen and (max-width: 768px) {
    .drawer-container {
      display: none !important;

      .drawer-content {
        .menu-wrapper {
          .main-menu {
            .main-section {
            }
          }

          .option-section {
          }
        }
      }

      .config-menu {
      }
    }
  }
`;
